import api from './api';

const BASE_URL = '/api/ReportIncident';

export const getReportIncidents = async ({ status = '', departmentGuid = '' } = {}) => {
  const params = {};
  if (status) params.status = status;
  if (departmentGuid) params.departmentGuid = departmentGuid;
  return api.get(`${BASE_URL}/admin`, { params });
};

export const getReportIncidentDepartments = async () =>
  api.get(`${BASE_URL}/departments`);

export const updateReportIncidentStatus = async (id, payload) =>
  api.put(`${BASE_URL}/admin/${id}/status`, payload);

export const getReportIncidentAssignments = async () =>
  api.get(`${BASE_URL}/admin/assignments`);

export const createReportIncidentAssignment = async (payload) =>
  api.post(`${BASE_URL}/admin/assignments`, payload);

export const deleteReportIncidentAssignment = async (id) =>
  api.delete(`${BASE_URL}/admin/assignments/${id}`);
